import { Button, Tooltip, Checkbox } from 'antd';

import PropTypes from 'prop-types';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Dropdown from './Dropdown';
import Icon from './Icon';

const ToolbarCheckboxGroup = ({
  isRadio,
  isAction,
  label,
  tooltip,
  icon,
  //
  bState,
  //
  groupId,
  // primary: _primary,
  secondary,
  items: _items,
  renderer,
  onInteraction,
  disabled,
}) => {
  const { t } = useTranslation('ViewerTool');
  const [isActive, setIsActive] = useState(false);

  const menuItems = _items.map((it) => ({
    key: it?.id,
    label: (
      <div className="flex items-center">
        {typeof it?.icon === 'string' ? (
          <Icon name={it?.icon} className={`mr-2 text-xl leading-none`} />
        ) : (
          <Checkbox
            checked={!!it?.commands?.[0]?.commandOptions?.toggledState}
            className="mr-2"
          />
        )}
        {t(it?.label)}
      </div>
    ),
    onClick: () => {
      onInteraction({
        groupId,
        //
        itemId: it.id,
        interactionType: it.type,
        // splitButtonId? (so we can track group?)
        // info to fire item's command/event?
        commands: it.commands,
      });
      if (typeof it?.icon === 'string') {
        setIsActive((prev) => !prev);
      }
    },
  }));

  return (
    <div className="relative flex">
      <Dropdown
        menu={{ items: menuItems }}
        open={isActive}
        placement="bottom"
        trigger={['click']}
        onOpenChange={(val) => setIsActive(val)}
        disabled={disabled}
        overlayStyle={{ zIndex: 1200 }}
        overlayClassName="vindr-dropdown dropdown-options-dark whitespace-nowrap"
      >
        <Tooltip title={t(tooltip)} placement="top">
          <Button
            type="link"
            className={`mx-1.5 h-6 rounded-sm p-0 outline-none`}
            onClick={() => {
              setIsActive((prev) => !prev);
            }}
            name={label}
            key={groupId}
            id={groupId}
          >
            <Icon
              name={icon}
              className={`text-4xl hover:text-primary-light ${
                isActive ? 'text-primary-light' : 'text-white'
              }`}
            />
          </Button>
        </Tooltip>
      </Dropdown>
    </div>
  );
};

ToolbarCheckboxGroup.defaultProps = {
  isRadio: false,
  isAction: false,
  /*
   */
  secondary: {
    icon: 'chevron-down',
    label: null,
    isActive: true,
    tooltip: 'More Measure Tools',
  },
  items: [],
};

ToolbarCheckboxGroup.propTypes = {
  /* primary: PropTypes.shape({
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.oneOf(['tool', 'action', 'toggle']).isRequired,
    tooltip: PropTypes.string,
  }), */
  secondary: PropTypes.shape({
    id: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    isActive: PropTypes.bool,
  }),
  renderer: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.oneOf(['tool', 'action', 'toggle']).isRequired,
      tooltip: PropTypes.string,
      isActive: PropTypes.bool,
    })
  ),
  /** Callback function to inform ToolBarService of important events */
  onInteraction: PropTypes.func.isRequired,
};

export default ToolbarCheckboxGroup;
